import { render } from "./RehabList.vue?vue&type=template&id=6007ab54&scoped=true"
import script from "./RehabList.vue?vue&type=script&lang=js"
export * from "./RehabList.vue?vue&type=script&lang=js"

import "./RehabList.vue?vue&type=style&index=0&id=6007ab54&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6007ab54"]])